exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column-blanco[data-v-014024c0]{padding-bottom:100px}.image[data-v-014024c0]{display:inline-block}.card[data-v-014024c0]:hover{transform:translateY(-5px) scale(1.005) translateZ(0);box-shadow:0 24px 36px rgba(0,0,0,.11),0 14px 16px rgba(0,0,0,.11)}.section-title[data-v-014024c0]{margin-top:1rem;margin-bottom:2rem}.card[data-v-014024c0]{color:#54545c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-014024c0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/HomeGA.vue
// module id = 3481
// module chunks = 0